export const FETCH_VACATIONS_REQUEST = 'FETCH_VACATIONS_REQUEST';
export const FETCH_VACATIONS_SUCCESS = 'FETCH_VACATIONS_SUCCESS';
export const FETCH_VACATIONS_FAILURE = 'FETCH_VACATIONS_FAILURE';

export const FETCH_VACATIONS_POOL_REQUEST = 'FETCH_VACATIONS_POOL_REQUEST';
export const FETCH_VACATIONS_POOL_SUCCESS = 'FETCH_VACATIONS_POOL_SUCCESS';
export const FETCH_VACATIONS_POOL_FAIL = 'FETCH_VACATIONS_POOL_FAIL';

export const CREATE_VACATION_REQUEST = 'CREATE_VACATION_REQUEST';
export const CREATE_VACATION_SUCCESS = 'CREATE_VACATION_SUCCESS';
export const CREATE_VACATION_FAIL = 'CREATE_VACATION_FAIL';
export const CREATE_VACATION_RESET = 'CREATE_VACATION_RESET';

export const DELETE_VACATION_REQUEST = 'DELETE_VACATION_REQUEST';
export const DELETE_VACATION_SUCCESS = 'DELETE_VACATION_SUCCESS';
export const DELETE_VACATION_FAIL = 'DELETE_VACATION_FAIL';
export const DELETE_VACATION_RESET = 'DELETE_VACATION_RESET';

export const UPDATE_VACATION_REQUEST = 'UPDATE_VACATION_REQUEST';
export const UPDATE_VACATION_SUCCESS = 'UPDATE_VACATION_SUCCESS';
export const UPDATE_VACATION_FAIL = 'UPDATE_VACATION_FAIL';
export const UPDATE_VACATION_RESET = 'UPDATE_VACATION_RESET';
